import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import { materialDetailService } from "_services";
import MaterailDetailSearch from "./Search";
import { DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import { Auth } from "_helpers";
import { CSVLink } from "react-csv";
import { render } from "react-dom/cjs/react-dom.production.min";

const List = ({ history, match }) => {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [loadingBarcodes, setLoadingBarcodes] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalGrossMeasure, setTotalGrossMeasure] = useState(0);
  const [searchParams, setSearchParams] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const loggedInCustomerCode = Auth.getProfile().comp_code;

  const { Text } = Typography;

  useEffect(() => {
    //getItems(pageNumber, pageSize);
  }, []);

  const getItems = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setLoading(true);
    materialDetailService
      .search(`${searchParams}${paginationParams}`)
      .then((data) => {
        setItems(data.content);
        setLoading(false);
        setTotalRecords(data.pagination.totalRecords);
        const grossMeasures = Object.values(data.pagination.totalGross);
        const grossMeasureSum =
          grossMeasures.length > 0 &&
          grossMeasures.reduce((prev, next) => prev + next);
        setTotalGrossMeasure(grossMeasureSum);
        setPageNumber(pageNumber);
        setPageSize(pageSize);
      })
      .catch((error) => {
        setLoading(false);
        message.error(`${error}`);
      });
  };

  const handleSearchResults = (results, pagination, searchParams) => {
    setItems(results);
    if (pagination) {
      setTotalRecords(pagination.totalRecords);
    }
    setSearchParams(searchParams);
    setPageNumber(1);
    setLoading(false);
  };

  const handlePaginateChange = (pageNumber, pageSize) => {
    //console.log("Page ChANGE:", pageNumber, ", pageSize:", pageSize);
    getItems(pageNumber, pageSize);
  };

  const onSelectChange = (selectedRowKeys) => {
    //console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
    setSelectedItems(
      items
        .filter((item) => selectedRowKeys.includes(item.id))
        .map((item) => ({
          id: item.id,
          preReceiptNumber:
            item.stockPreReceiptLine &&
            item.stockPreReceiptLine.stockPreReceipt &&
            item.stockPreReceiptLine.stockPreReceipt.preReceiptNumber,
          packSerial: item.packSerialNo,
          runningNo: item.runningNo,
          lotNumber: item.lotNumber.number,
          stockType: item.stockType.code,
          quantity: item.quantity,
          netWeight: item.netWeight,
          grossWeight: item.grossWeight,
          grossValueSqm: item.grossValueSqm,
          uom: item.measurementType && item.measurementType.name,
        }))
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
    /* selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ], */
  };

  /* const handleDelete = (id) => {
    materialDetailService
      .delete(id)
      .then((x) => {
        getItems(pageNumber, pageSize);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  }; */

  const handleBinTransfer = () => {
    const stockItems = items.filter(
      (item) => selectedRowKeys.includes(item.id) && item.mode === "AVAILABLE"
    );

    if (stockItems.length > 0 && selectedRowKeys.length === stockItems.length) {
      history.push({
        pathname: `${path}/bin-transfer`,
        store: stockItems[0].owner,
        storeLocation: stockItems[0].stockBin.storeLocation,
        stockItems: stockItems,
      });
    } else {
      message.info("Please select only available stocks to be transfer");
    }
  };

  const handleMaterialTypeTransfer = () => {
    const stockItems = items.filter(
      (item) => selectedRowKeys.includes(item.id) && item.mode === "AVAILABLE"
    );

    if (stockItems.length > 0 && selectedRowKeys.length === stockItems.length) {
      history.push({
        pathname: `${path}/material-type-transfer`,
        stockItems: stockItems,
      });
    } else {
      message.info("Please select only available stocks to be transfer");
    }
  };

  const handleLotNumberTransfer = () => {
    const stockItems = items.filter(
      (item) => selectedRowKeys.includes(item.id) && item.mode === "AVAILABLE"
    );

    if (stockItems.length > 0 && selectedRowKeys.length === stockItems.length) {
      history.push({
        pathname: `${path}/lot-transfer`,
        stockItems: stockItems,
      });
    } else {
      message.info("Please select only available stocks to be transfer");
    }
  };

  const handleGenerateBarcodes = () => {
    if (selectedRowKeys.length > 0) {
      const payload = {
        stockItems: selectedRowKeys.map((item) => ({
          id: item,
        })),
      };
      //console.log("Barcode PL:", payload);
      setLoadingBarcodes(true);
      materialDetailService
        .generateAndDownloadBarcodes(payload)
        .then((response) => {
          /* var blob=new Blob([response], {type:"application/pdf"});
          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download="Report_"+new Date()+".pdf";
          link.click(); */

          const url = window.webkitURL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Barcodes_${moment(new Date()).format("YYYY-MM-DD")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoadingBarcodes(false);
        })
        .catch((error) => {
          setLoadingBarcodes(false);
          message.error(error);
        });
    }
  };

  const handleExportExcel = () => {
    setLoadingExcel(true);
    materialDetailService
      .exportExcel(searchParams)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Stock-Details_${moment(new Date()).format("YYYY-MM-DD hh:mm")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingExcel(false);
      })
      .catch((error) => {
        setLoadingExcel(false);
        message.error(error);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    if (selectedRowKeys.length > 0) {
      buttons.push(
        <span style={{ marginLeft: 8 }}>
          Selected {selectedRowKeys.length} items
        </span>
      );
    }
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Button
          key="excel"
          icon={<FileExcelOutlined />}
          disabled={items.length === 0}
          onClick={handleExportExcel}
          loading={loadingExcel}
        ></Button>
      );
      /* buttons.push(
        <Button
          key="update"
          icon={<UploadOutlined />}
          href={`${path}/update-via-upload`}
          loading={loadingBarcodes}
        ></Button>
      ); */
      /* buttons.push(
        <Button
          key="barcode"
          icon={<BarcodeOutlined />}
          disabled={selectedRowKeys.length === 0}
          onClick={handleGenerateBarcodes}
          loading={loadingBarcodes}
        ></Button>
      ); */
      /* buttons.push(
        <Button
          key="bin-transfer"
          disabled={selectedRowKeys.length === 0}
          onClick={handleBinTransfer}
        >
          Bin Transfer
        </Button>
      ); */
      /* buttons.push(
        <Button
          key="material-type-transfer"
          disabled={selectedRowKeys.length === 0}
          onClick={handleMaterialTypeTransfer}
        >
          MT Transfer
        </Button>
      ); */
    }
    return buttons;
  };

  const getColumns = () => {
    let columns = [];
    columns.push({
      title: "Material",
      key: "stockType",
      render: (text, record) => {
        return (
          <>
            <Link to={`/material-details/${record.id}/summary`}>
              {record.stockTypeCode}
            </Link>
            <Input value={record.id} hidden />
          </>
        );
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockTypeName}>
            {record.stockTypeName}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Stock Class",
      key: "stockClass",
      render: (text, record) => record.stockClassificationName,
    });
    columns.push({
      title: "Receipt Number",
      key: "receiptNumber",
      render: (text, record) => record.receiptNumber,
    });
    columns.push({
      title: "Rec’d. Date",
      key: "receivedDate",
      render: (text, record) => record.receivedDate,
    });
    /* columns.push({
      title: "Delivery No:",
      key: "deliveryNumber",
      render: (text, record) => {
        return (
          record.issuedLine &&
          record.issuedLine.stockIssue &&
          record.issuedLine.stockIssue.issueNumber
        );
      },
    }); */
    columns.push({
      title: "Packing Type",
      key: "packingType",
      render: (text, record) => record.packingType,
    });
    columns.push({
      title: "Stock Bin",
      key: "stockBin",
      render: (text, record) => {
        return record.stockBinCode;
      },
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "Rec’d. Qty",
      key: "quantity",
      align: "right",
      render: (text, record) => {
        return record.totalItems;
      },
    });
    columns.push({
      title: "Rec’d. Gross.W",
      dataIndex: "grossWeight",
      key: "grossWeight",
      align: "right",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    });

    return columns;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-details">Material Detail Search</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <MaterailDetailSearch
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
            loggedInCustomerCode={loggedInCustomerCode}
          />
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={getColumns()}
            dataSource={items}
            rowSelection={rowSelection}
            //expandable={{ expandedRowRender, defaultExpandAllRows: true }}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              pageSizeOptions: [10, 20, 50, 100, 200, 500, 1000, 1500],
              showSizeChanger: true,
              onChange: handlePaginateChange,
            }}
            summary={(pageData) => {
              let totalQuantity = 0;

              pageData.forEach(({ totalItems }) => {
                totalQuantity += totalItems;
              });
              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell colSpan={8}>
                      <Text strong>Total</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      <Text strong style={{ paddingLeft: 12 }}>
                        {totalRecords}
                      </Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      {!isNaN(totalQuantity) && Number(totalQuantity)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              );
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

export default List;
